import {toRaw} from "vue";
import {useInlineExercise} from "@/modules/reader/inlineExercise/inlineExercise";
import {getCurrentLocalHistory} from "@/modules/localDB/bookQuery";
import {db} from "@/modules/localDB/localDB";

/**
 * Used for saving inline exercsie data to local db
 * @param answers
 * @param pagenum
 * @returns {Promise<*>}
 */

const saveAnswers = async(answers, pagenum)=> {

    let pagesWithLocalChange = [];
    const record = await getCurrentLocalHistory();

    if (record) {

        let currentInlineExHistory = record.inlineExercise;

        if (record.pagesWithLocalChange) {
            pagesWithLocalChange = record.pagesWithLocalChange;
        }

        if (pagesWithLocalChange.indexOf(pagenum) < 0) {
            pagesWithLocalChange.push(pagenum)
        }


        //if no inline exercise history in stored, directly modify the record with inline exercise data:
        if (!currentInlineExHistory) {
            useInlineExercise().updateEntireBookAnswers([answers]);
            return await db.reader
                .where("[membercode+ebookcode]")
                .equals([localStorage.membercode, localStorage.ebookcode])
                .modify({inlineExercise: [answers],pagesWithLocalChange:pagesWithLocalChange});

        //otherwise, check if current page inline exercise data exists, since the record stores all current book exercise data,
        //while the submit button only saves the current page exercise data.
        } else {

            let isSubmittedBefore = false;

            for (let item of currentInlineExHistory) {
                //update answer content if the exercise has been submitted before.
                if (item.exercisecode === answers.exercisecode) {
                    isSubmittedBefore = true;
                    item.content = answers.content
                }
            }

            //if not submitted before, populate the current exercise
            if (!isSubmittedBefore) {
                currentInlineExHistory.push(answers);
            }

            useInlineExercise().updateEntireBookAnswers(currentInlineExHistory)
            return await db.reader
                .where("[membercode+ebookcode]")
                .equals([localStorage.membercode, localStorage.ebookcode])
                .modify({inlineExercise: currentInlineExHistory, pagesWithLocalChange:pagesWithLocalChange});

        }

    } else {

        pagesWithLocalChange.push(pagenum);
        useInlineExercise().updateEntireBookAnswers([answers]);

        return await db.reader
            .where("[membercode+ebookcode]")
            .equals([localStorage.membercode, localStorage.ebookcode])
            .modify({inlineExercise: [answers], pagesWithLocalChange:pagesWithLocalChange });
    }

}

/**
 * Used when restoring inline exercise data from remote
 */
const updateAnswersFromRemote =  async (answers) => {

    //Directly replace the db data with the remote answers
    const result = await db.reader
        .where("[membercode+ebookcode]")
        .equals([localStorage.membercode, localStorage.ebookcode])
        .modify({inlineExercise: answers });

    useInlineExercise().updateEntireBookAnswers(answers);
    return result;

}

export {
    saveAnswers,
    updateAnswersFromRemote
}